import { combineReducers } from '@reduxjs/toolkit';
import participantReducer from './participant/participantSlice';
import episodeActivity from './episode/activitiesTab/episodeActivity/episodeActivitySlice';
import episodeReducer from './episode/episodeSlice';
import participantsReferenceData from './participantsReferenceData/ParticipantsReferenceDataSlice';
import stopModulesData from './stopmodule/stopModuleSlice';
import profA1ReferenceData from './episode/profA1Tab/profA1ReferenceSlice';
import referralForm from './episode/referralTab/referralFormSlice';
import activitiesRefernceData from './episode/activitiesTab/activitiesReferenceSlice';
import referralRefernceData from './episode/referralTab/referralReferenceSlice';
import profA1Form from './episode/profA1Tab/profA1FormSlice';
import profA2ReferenceData from './episode/profA2Tab/profA2ReferenceSlice';
import profA2Form from './episode/profA2Tab/profA2FormSlice';
import profB1Form from './episode/profB1Tab/profB1FormSlice';
import profB1RefernceData from './episode/profB1Tab/profB1ReferenceSlice';
import profB2Form from './episode/profB2Tab/profB2FormSlice';
import profB2RefernceData from './episode/profB2Tab/profB2ReferenceSlice';
import episodeAorcm from './episode/aorvmTab/episodeAorcmSlice';
import aorcmReferenceData from './episode/aorvmTab/aorcmReferenceSlice';
import qualityAssuranceReducer from './episode/qualityAssuranceTab/qualityAssuranceSlice';
import qualityAssuranceDetailForm from './episode/qualityAssuranceTab/qualityAssuranceDetail/qualityAssuranceDetailSlice';
import qualityAssuranceReferenceData from './episode/qualityAssuranceTab/qualityAssuranceReferenceSlice';
import stsAlertReferenceData from './episode/stsAlertTab/stsAlertReferenceSlice';
import stsAlertForm from './episode/stsAlertTab/stsAlertForm';
import form2284 from './episode/2284Tab/2284Form/2284Slice';
import reference2284Data from './episode/2284Tab/2284Reference/2284ReferenceSlice';
import reportingProgramOrganizationAddress from './episode/2284Tab/2284ReportingProgramOrgAddress/2284ReportingProgramOrgAddressSlice';
import transportReferenceData from './episode/transportTab/transportReference/transportReferenceSlice';
import transportForm from './episode/transportTab/transportForm/transportSlice';
import cmpReferenceData from './episode/cmpTab/cmpReference/cmpReferenceSlice';
import cmpForm from './episode/cmpTab/cmpForm/cmpSlice';
import episodeParticipantReducer from './episode/cmpTab/cmpReference/cmpReferenceSlice';
import newEpisodeReferenceData from './participant/newEpisode/NewEpisodeReference';
import newEpisodeFormData from './participant/newEpisode/NewEpisodeSlice';
import cbpCaseManagerReferenceData from './cbp/cbpCaseManager/cbpCaseManagerReferenceSlice';
import cbpCaseManagerForm from './cbp/cbpCaseManager/cbpCaseManagerSlice';
import authReferenceData from './episode/authTab/authReferenceSlice';
import authForm from './episode/authTab/authFormSlice';
import authPdfForm from './episode/authTab/authPdfSlice';
import cbpAuthForm from './episode/authTab/cbpAuthFormSlice';
import cbpAuthPdfForm from './episode/authTab/cbpAuthPdfSlice';
import cbpRatesFormData from './cbp/cbpRates/cbpRatesFormSlice';
import cbpReferenceData from './cbp/cbpRates/cbpRatesReferenceData';
import cbpForm from './cbp/cbpForm/cbpFormSlice';
import cbpFormReferenceData from './cbp/cbpForm/cbpReferenceSlice';
import verificationReferenceData from './verification/verificationMasterData';
import verificationMonthData from './verification/verificationGetMonth';
import verificationListSlice from './verification/VerificationSlice';
import verifySliceForm from './verification/VerifySliceForm';
import verifyMasterReferenceData from './verification/GetVerificationMasterReferenceData';
import VerificationDialogPopupSlice from './verification/verificationDialogPopupData';
import AddParticipantReferenceData from './participant/AddParticipant/addParticipantReferenceData';
import AddParticipantFormSlice from './participant/AddParticipant/addParticipantSliceForm';
import participantComment from './participant/ParticipantComment/ParticipantCommentSlice';
import contactReferenceData from './contact/contactForm/contactReferenceSlice';
import contactForm from './contact/contactForm/contactFormSlice';
import contactOrganizationAddress from './contact/contactOrganizationAddress/contactOrganizationAddressSlice';
import referralSourceForm from './contact/referralSourcesForm/referralSourcesFormSlice';
import verificationDynamicMasterDate from './verification/verificationDynamicMasterDate';
import verificationGroupMasterData from './verification/verificationGroupMasterData';
import verificationDischargeMasterData from './verification/verificationDischargeMasterData';
import organizationReferenceData from './organization/organizationForm/organizationReferenceSlice';
import organizationForm from './organization/organizationForm/organizationFormSlice';
import addressAndContactsForm from './organization/organizationTabs/addressAndContacts/addressAndContactsSlice';
import organizationContactForm from './organization/organizationTabs/addressAndContacts/organizationContacts/organizationContactsSlice';
import organizationComplianceForm from './organization/organizationTabs/organizationCompliance/organizationComplianceSlice';
import organizationComplianceListForm from './organization/organizationTabs/organizationCompliance/organizationComplianceList/organizationComplianceDataSlice';
import organizationSapForm from './organization/organizationTabs/organizationSap/organizationSapForm/organizationSapSlice';
import organizationSapActivitiesContactForm from './organization/organizationTabs/organizationSap/organizationSapActivitiesContacts/organizationSapActivitiesContactsSlice';
import organizationInstitutionForm from './organization/organizationTabs/organizationInstitution/organizationInstitutionSlice';
import organizationCommentForm from './organization/organizationTabs/organizationComments/organizationCommentsSlice';
import organizationRegionForm from './organization/organizationTabs/organizationRegion/organizationRegionSlice';
import invoiceReferenceData from './invoices/invoiceReferenceSlice';
import invoicesDetails from './invoices/invoicesSlice';
import invoiceCbpIds from './invoices/cbpInvoiceIdsSlice';
import cbpInvoiceForm from './invoices/cbpInvoiceDetail/cbpInvoiceDetailSlice';
import verificationIndividual1 from './verification/verificationDropdowns/verificationIndividual1';
import verificationIndividual3 from './verification/verificationDropdowns/verificationIndividual3';
import verificationIndividual4 from './verification/verificationDropdowns/verificationIndividual4';
import verificationIndividual5 from './verification/verificationDropdowns/verificationIndividual5';
import verificationIndividual6 from './verification/verificationDropdowns/verificationIndividual6';
import verificationIndividual7 from './verification/verificationDropdowns/verificationIndividual7';
import verificationGroup1 from './verification/verificationDropdowns/verificationGroup1';
import verificationGroup3 from './verification/verificationDropdowns/verificationGroup3';
import verificationGroup4 from './verification/verificationDropdowns/verificationGroup4';
import verificationGroup5 from './verification/verificationDropdowns/verificationGroup5';
import verificationGroup6 from './verification/verificationDropdowns/verificationGroup6';
import verificationGroup7 from './verification/verificationDropdowns/verificationGroup7';
import verificationDischarge1 from './verification/verificationDropdowns/verificationDischarge1';
import verificationDischarge3 from './verification/verificationDropdowns/verificationDischarge3';
import verificationDischarge4 from './verification/verificationDropdowns/verificationDischarge4';
import verificationDischarge5 from './verification/verificationDropdowns/verificationDischarge5';
import verificationDischarge6 from './verification/verificationDropdowns/verificationDischarge6';
import verificationDischarge7 from './verification/verificationDropdowns/verificationDischarge7';
import reportForm from './report/reportForm/reportSlice';
import calOMSAdmitPdfForm from '../components/Episode/EpisodeForms/AuthTab/CalOMS/store/CalOMSAdmit/CalOMSAdmitAuthPdfSlice';
import CalOMSDischargeForm from '../components/Episode/EpisodeForms/AuthTab/CalOMS/store/CalOMSDischarge/CalOMSDischargeAuthPdfSlice';
import referalPdfForm from './episode/referralTab/referalTabPdf/referalPdfSlice';
import incidentReportPdfForm from '../components/Episode/EpisodeForms/2284Tab/2284List/incidentReportPdfSlice';
import transportPdfForm from '../components/Episode/EpisodeForms/TransportTab/TransportDialog/TransportPdfSlice';
import queryBuilder from './queryBuilder/queryBuilderSlice';

export const rootReducer = combineReducers({
  participants: participantReducer,
  episodeDetail: episodeReducer,
  episodeParticipantData: episodeParticipantReducer,
  episodeActivity: episodeActivity,
  episodeAorcm,
  qualityAssurance: qualityAssuranceReducer,
  participantsReferenceData,
  stopModulesData,
  profA1ReferenceData,
  referralForm,
  referralRefernceData,
  profA1Form,
  profB1Form,
  profB1RefernceData,
  profB2Form,
  profB2RefernceData,
  activitiesRefernceData,
  profA2ReferenceData,
  profA2Form,
  aorcmReferenceData,
  qualityAssuranceReferenceData,
  qualityAssuranceDetailForm,
  stsAlertReferenceData,
  stsAlertForm,
  form2284,
  reference2284Data,
  reportingProgramOrganizationAddress,
  transportReferenceData,
  transportForm,
  cmpReferenceData,
  cmpForm,
  newEpisodeReferenceData,
  newEpisodeFormData,
  cbpCaseManagerReferenceData,
  cbpCaseManagerForm,
  authReferenceData,
  authForm,
  authPdfForm,
  cbpAuthForm,
  cbpAuthPdfForm,
  cbpRatesFormData,
  cbpReferenceData,
  cbpForm,
  cbpFormReferenceData,
  verificationReferenceData,
  verificationMonthData,
  verificationListSlice,
  verificationIndividual1,
  verificationDynamicMasterDate,
  verificationIndividual3,
  verificationIndividual4,
  verificationIndividual5,
  verificationIndividual6,
  verificationIndividual7,
  verificationGroup1,
  verificationGroupMasterData,
  verificationGroup3,
  verificationGroup4,
  verificationGroup5,
  verificationGroup6,
  verificationGroup7,
  verificationDischarge1,
  verificationDischargeMasterData,
  verificationDischarge3,
  verificationDischarge4,
  verificationDischarge5,
  verificationDischarge6,
  verificationDischarge7,
  verifySliceForm,
  verifyMasterReferenceData,
  VerificationDialogPopupSlice,
  AddParticipantReferenceData,
  AddParticipantFormSlice,
  participantComment,
  contactReferenceData,
  contactForm,
  contactOrganizationAddress,
  referralSourceForm,
  organizationReferenceData,
  organizationForm,
  addressAndContactsForm,
  organizationContactForm,
  organizationComplianceForm,
  organizationComplianceListForm,
  organizationSapForm,
  organizationSapActivitiesContactForm,
  organizationInstitutionForm,
  organizationRegionForm,
  organizationCommentForm,
  invoiceReferenceData,
  invoicesDetails,
  invoiceCbpIds,
  cbpInvoiceForm,
  reportForm,
  calOMSAdmitPdfForm,
  CalOMSDischargeForm,
  referalPdfForm,
  incidentReportPdfForm,
  transportPdfForm,
  queryBuilder,
});
